import React from 'react';

interface LogoStaticProps {
  className?: string;
}

/**
 * ColorScales Logo - Static version
 * Uses CSS custom properties for dynamic theming
 * Apply className to control tile colors via SCSS
 */
export const LogoStatic = React.forwardRef<SVGSVGElement, LogoStaticProps>(
  ({ className }, ref) => {
    return (
      <svg 
        ref={ref}
        width="128" 
        height="128" 
        viewBox="0 0 128 128" 
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g id="logo">
          <g id="grid">
            {/* Tile 09 - Top right tall */}
            <rect 
              x="86" 
              y="70" 
              width="12" 
              height="28" 
              rx="3" 
              className="logo-static__tile"
            />
            
            {/* Tile 08 - Top center tall */}
            <rect 
              x="64" 
              y="70" 
              width="16" 
              height="28" 
              rx="3" 
              className="logo-static__tile"
            />
            
            {/* Tile 07 - Top left tall (RED) */}
            <rect 
              x="30" 
              y="70" 
              width="28" 
              height="28" 
              rx="3" 
              className="logo-static__tile logo-static__tile--red"
            />
            
            {/* Tile 06 - Middle right */}
            <rect 
              x="86" 
              y="48" 
              width="12" 
              height="16" 
              rx="3" 
              className="logo-static__tile"
            />
            
            {/* Tile 05 - Middle center (ORANGE) */}
            <rect 
              x="64" 
              y="48" 
              width="16" 
              height="16" 
              rx="3" 
              className="logo-static__tile logo-static__tile--orange"
            />
            
            {/* Tile 04 - Middle left */}
            <rect 
              x="30" 
              y="48" 
              width="28" 
              height="16" 
              rx="3" 
              className="logo-static__tile"
            />
            
            {/* Tile 03 - Bottom right (BLUE) */}
            <rect 
              x="86" 
              y="30" 
              width="12" 
              height="12" 
              rx="3" 
              className="logo-static__tile logo-static__tile--blue"
            />
            
            {/* Tile 02 - Bottom center */}
            <rect 
              x="64" 
              y="30" 
              width="16" 
              height="12" 
              rx="3" 
              className="logo-static__tile"
            />
            
            {/* Tile 01 - Bottom left */}
            <rect 
              x="30" 
              y="30" 
              width="28" 
              height="12" 
              rx="3" 
              className="logo-static__tile"
            />
          </g>
        </g>
      </svg>
    );
  }
);

// Add display name for better debugging
LogoStatic.displayName = 'LogoStatic';

